module.exports = __webpack_public_path__ + "img/Background-Stretched-Canvas-no-text-jpg.2105b164.webp";